<template>
    <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase C — outerPath click 시 사이드바 자동 close (D-3) -->
    <!--   router-link는 App.vue route watcher가 close 처리, 외부 탭(target=_blank)은 라우트 변경 없어 별도 commit 필요 -->
    <a v-if="outerPath" :href="outerPath" target="_blank" class="sidenav-item-container" v-bind="$attrs" @click="$store.commit('closeSidenav')">
        <div
            class="sidenav-item-icon"
        >
            <slot name="icon"/>
        </div>
        <div class="sidenav-item-text">{{ navText }}</div>
    </a>
    <router-link v-else :to="url" class="sidenav-item-container" v-bind="$attrs">
        <div
            class="sidenav-item-icon"
        >
            <slot name="icon"/>
        </div>
        <div class="sidenav-item-text" :class="isDentium ? 'dentium' : ''">
            {{ navText }}
            <img v-if="isDentium" src="@/assets/img/sidenav/badge_Dentium.svg"/>
        </div>
    </router-link>
</template>
<script>
    export default {
        name: 'sidenav-item',
        props: {
            url: {
                type: String,
                required: false
            },
            navText: {
                type: String,
                required: true
            },
            outerPath: {
                type: String,
                required: false
            },
            isDentium: {
                type: Boolean,
                required: false
            },
        }
    };
</script>
